import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%", height: "100%" } },
    [
      _c(
        VRow,
        { attrs: { "no-gutters": "" } },
        [
          _c("attribute-filter-panel", {
            attrs: {
              "title-localisation": "attributes.filters.filterByAttributes",
              "filter-count-localisation": "attributes.filters.numApplied",
              "enable-hierarchy-filters": "",
              "enable-attribute-description-filter": "",
              "enable-attribute-filters": false,
              "enable-non-attribute-filters": false,
              "enable-store-group-chain-filter": false,
              "enable-tool-store-group-filter": false,
              "enable-client-product-key-filter": false,
              "enable-similarity-group-filter": false,
              "enable-cann-group-filter": false,
              "hierarchy-filter-level": _vm.hierarchyFilterLevel,
              "filter-rules": _vm.anchorMarginFilter,
            },
            on: { attributeFilterChange: _vm.setFilterRules },
          }),
          _vm._v(" "),
          _c(
            VAlert,
            {
              attrs: {
                value: _vm.missingFilters,
                color: "warning",
                icon: "warning",
                outlined: "",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t(`anchorMargin.missingFiltersWarning`)) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.anchorMargins.length
        ? _c(VFlex, { attrs: { xs4: "" } }, [
            _c(
              "div",
              { staticClass: "toggles ml-2 mr-2 mb-2" },
              [
                _c(
                  "div",
                  { staticClass: "switch-prefix" },
                  [
                    _c(VLabel, [
                      _vm._v(_vm._s(_vm.$t("anchorMargin.toggles.lock"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      VIcon,
                      {
                        staticClass: "mr-2",
                        attrs: { size: "1.8rem", right: "" },
                      },
                      [_vm._v("mdi-lock")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(VSwitch, {
                  staticClass: "mr-4 pt-0",
                  attrs: {
                    disabled: _vm.editsExist || _vm.isSaving,
                    primary: "",
                    dense: "",
                    "hide-details": "",
                  },
                  on: { change: _vm.toggleEditMode },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("anchorMargin.toggles.edit")) +
                                "\n          "
                            ),
                            _c(
                              VIcon,
                              { attrs: { size: "1.8rem", right: "" } },
                              [_vm._v("mdi-pencil")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    288969260
                  ),
                  model: {
                    value: _vm.editMode,
                    callback: function ($$v) {
                      _vm.editMode = $$v
                    },
                    expression: "editMode",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.missingFilters
        ? _c("ag-grid-vue", {
            staticClass: "ag-theme-custom ag-anchor-margins-grid",
            style: { width: "100%", height: `${_vm.dataTableHeight}px` },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
            },
            on: { "grid-ready": _vm.onGridReady },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.anchorMargins.length
        ? _c("div", { staticClass: "anchor-margins-footer" }, [
            _c(
              "div",
              { staticClass: "anchor-margins-footer__btn-container" },
              [
                _c(
                  VBtn,
                  {
                    staticClass: "grid-btn",
                    attrs: {
                      disabled: _vm.isSaving,
                      secondary: "",
                      small: "",
                      depressed: "",
                    },
                    on: { click: _vm.resetGrid },
                  },
                  [_vm._v(_vm._s(_vm.$t("inputs.cancel")))]
                ),
                _vm._v(" "),
                _c(
                  VBtn,
                  {
                    attrs: {
                      small: "",
                      color: "primary",
                      loading: _vm.isSaving,
                      disabled: _vm.isSaving || !_vm.editsExist,
                      depressed: "",
                    },
                    on: { click: _vm.saveChanges },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("actions.save")) +
                        "\n        "
                    ),
                    _c(VIcon, { attrs: { small: "" } }, [_vm._v("$import")]),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }